import { z } from 'zod';

export const annotationsCountTableSchema = z.object({
  type: z.literal('annotationsCount'),
  data: z.array(
    z.object({
      student: z.object({
        id: z.string(),
        lastName: z.string(),
        firstName: z.string(),
      }),
      count: z.number(),
    })
  ),
});

export type AnnotationsCountTableResponse = z.infer<
  typeof annotationsCountTableSchema
>;
